import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw, XCircle, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const jobPending = (job) => ["QUEUED", "RUNNING", "FAILED"].includes(job?.status);

export function RecoveryStatus({ job, onChange, prefix = "recovery" }) {
  const [acting, setActing] = useState(false);
  if (!job) return null;
  const running = ["QUEUED", "RUNNING"].includes(job.status);
  const act = async (action) => {
    setActing(true);
    try { const { data } = await axios.post(`${API}/jobs/${job.id}/${action}`); onChange?.(data); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not update the saved job"); }
    finally { setActing(false); }
  };
  return <div className="rounded-lg border border-line bg-surface p-3 text-xs" role="status" data-testid={`${prefix}-status`}>
    <div className="flex items-center gap-2 font-semibold text-ink">{running ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CheckCircle2 className="h-3.5 w-3.5" />}{job.progress?.stage || job.status}</div>
    <p className="mt-1 text-ink-muted" data-testid={`${prefix}-message`}>{running ? "Saved securely. You can close this window; processing continues. After a server interruption, recovery may take up to 10 minutes." : job.status === "FAILED" ? "Your input and completed steps are saved. Retry resumes the same operation." : job.status === "CANCELLED" ? "Cancelled. Your submitted input remains saved." : "Result saved. Reopening this window restores your progress."}</p>
    <div className="mt-2 flex gap-2">
      {["FAILED", "CANCELLED"].includes(job.status) && <Button variant="outline" size="sm" disabled={acting} onClick={() => act("retry")} data-testid={`${prefix}-retry`}><RefreshCw className="mr-1 h-3 w-3" />Resume saved job</Button>}
      {(running || job.status === "FAILED") && <Button variant="ghost" size="sm" disabled={acting || job.committing} onClick={() => act("cancel")} data-testid={`${prefix}-cancel`}><XCircle className="mr-1 h-3 w-3" />Cancel processing</Button>}
    </div>
  </div>;
}
